import React from 'react';
import { useStyletron } from 'baseui';
import { LabelXSmall } from 'baseui/typography';
import { RELATIONSHIP_CONSTANTS } from '../../constants';
import type { RelationshipT } from '../../types/relationship';
import RelationshipItem from './relationship-item';
type RelationshipsListProps = {
  relationships: RelationshipT[];
  getTargetDisplayName: (annotationId: string) => string;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  isVideoTask?: boolean;
  readOnly?: boolean;
};
const RelationshipsList = ({
  relationships,
  getTargetDisplayName,
  onEdit,
  onDelete,
  isVideoTask,
  readOnly
}: RelationshipsListProps) => {
  const [css, theme] = useStyletron();
  if (relationships.length === 0) {
    return <LabelXSmall color={theme.colors.contentSecondary}>
        {RELATIONSHIP_CONSTANTS.NO_RELATIONSHIPS}
      </LabelXSmall>;
  }
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale500,
    paddingBottom: theme.sizing.scale600
  })}>
      {relationships.map(relationship => <RelationshipItem key={relationship.id} relationship={relationship} targetDisplayName={getTargetDisplayName(relationship.targetAnnotationId)} onEdit={onEdit} onDelete={onDelete} isVideoTask={isVideoTask} readOnly={readOnly} />)}
    </div>;
};
export default RelationshipsList;